var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "router-link",
        {
          attrs: {
            to: {
              name: "talent.profile.show",
              params: { id: _vm.responded.id },
            },
          },
        },
        [
          _c("div", { staticClass: "details" }, [
            _c("div", { staticClass: "details" }, [
              _c("h2", { staticClass: "h5" }, [
                _vm._v(_vm._s(_vm.responded.name)),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "text-black-50" }, [
        _vm._v("Responded: "),
        _c("br"),
        _vm._v(
          _vm._s(
            _vm._f("timeTimezone")(_vm.responded.created_at, _vm.$user.timezone)
          ) +
            " on " +
            _vm._s(
              _vm._f("dateTimezone")(
                _vm.responded.created_at,
                _vm.$user.timezone,
                _vm.$user.date_format_preference
              )
            )
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }